<app-common-modal-wrapper
  closeBtnText="Cancel"
  saveBtnText="Save"
  header="Edit Agent Profile"
  icon="ic-edit-20"
  [formGroup]="form"
  [isLoading]="isLoading"
  (submitModal)="save()"
  (close)="cancel()"
>
  <div class="two-piece-input-wrapper">
    <app-input
      label="Agent Name"
      formControlName="firmName"
      [customErrors]="{ maxLength: 'You\'ve exceeded the 50 character limit.' }"
    />

    <app-input
      label="Agent Number"
      formControlName="agentNumber"
      [customErrors]="agentNumberCustomErrors"
    />
  </div>

  <div class="form-group">
    <app-select
      label="ASIC Contact"
      formControlName="contactPerson"
      [options]="asicContacts"
      [valuePrimitive]="true"
    />
  </div>

  <div class="form-group">
    <app-address-form-group
      [formGroup]="form.controls.address"
      [hideWarningMessage]="true"
    />
  </div>

  <div class="two-piece-input-wrapper">
    <app-input-phone-number formControlName="phone"/>

    <app-input
      label="Email"
      formControlName="email"
    />
  </div>

  <app-divider margin="24px 0"/>

  <div class="two-piece-input-wrapper">
    <app-input
      label="EDGE Login"
      formControlName="edgeLogin"
      [warningTooltipMessage]="edgeLoginTip"
      [customErrors]="edgeLoginCustomErrors"
    />

    <app-input-password
      label="EDGE Password"
      formControlName="edgePassword"
    />
  </div>
</app-common-modal-wrapper>
